import React from 'react';

export function IconManualTrade({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="40" height="40" fill="none" aria-hidden>
      <path
        d="M4 19h16M7 16l3-9 4 5 3-7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7" cy="16" r="1.5" fill="currentColor" />
      <circle cx="14" cy="12" r="1.5" fill="currentColor" />
      <circle cx="17" cy="5" r="1.5" fill="currentColor" />
    </svg>
  );
}

export function IconObot({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="40" height="40" fill="none" aria-hidden>
      <rect x="5" y="8" width="14" height="11" rx="2" stroke="currentColor" strokeWidth="2" />
      <circle cx="9" cy="13" r="1.25" fill="currentColor" />
      <circle cx="15" cy="13" r="1.25" fill="currentColor" />
      <path d="M9 5h6M12 5V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 19v2M16 19v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconGear({ className = '', size = 22 }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden>
      <path
        d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M19.4 13.5l1.2.7-1.2 2.1-1.4-.3a7.2 7.2 0 0 1-1.2.9l.2 1.4-2.4.4-.7-1.3a7.5 7.5 0 0 1-1.4 0l-.7 1.3-2.4-.4.2-1.4a7.2 7.2 0 0 1-1.2-.9l-1.4.3-1.2-2.1 1.2-.7a7.5 7.5 0 0 1 0-1.4l-1.2-.7 1.2-2.1 1.4.3c.4-.4.8-.7 1.2-.9l-.2-1.4 2.4-.4.7 1.3c.5-.1 1-.1 1.4 0l.7-1.3 2.4.4-.2 1.4c.4.2.8.5 1.2.9l1.4-.3 1.2 2.1-1.2.7c.1.5.1 1 0 1.4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Linked / connect wallet — bifold pocket wallet (header gear buttons). */
export function IconWalletLink({ className = '', size = 22 }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden>
      <path
        d="M17 8V6a1 1 0 0 0-1-1H7a2 2 0 0 0 0 4h9a1 1 0 0 1 1 1v2"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12h11a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.5" cy="15.5" r="1.25" fill="currentColor" />
    </svg>
  );
}
